import { Chip, styled } from "@mui/material";

/**
 * A styled chip that displays a verification status (e.g. Verified / Not Verified).
 * Uses success colors when verified, error colors when not.
 *
 * Usage:
 * ```tsx
 * <VerificationStatusChip label="Verified" isVerified />
 * <VerificationStatusChip label="Not Verified" isVerified={false} />
 * ```
 */
export const VerificationStatusChip = styled(Chip, {
  shouldForwardProp: prop => prop !== "isVerified",
})<{ isVerified: boolean }>(({ theme, isVerified }) => ({
  height: "auto",
  borderRadius: theme.spacing(2),
  backgroundColor: isVerified ? theme.palette.success.main : theme.palette.error.light,
  color: isVerified ? theme.palette.common.white : theme.palette.error.dark,
  "& .MuiChip-label": {
    padding: theme.spacing(0.5, 1.25),
    ...theme.typography.caption,
  },
}));
